import type { LoadLocationDataParams } from "../map/types";
import { validateZipcode } from "../../utils/validation";
import type { MapParamsGatheringModule } from "../../@types/mapviewxs";

export interface Input {
  visible?: boolean;
  mapParamsGathering?: Partial<MapParamsGatheringModule>;
  loading?: boolean;
  userLocationZipcode?: string;
  "on-close"?: () => void;
  "on-submit"?: (data: LoadLocationDataParams) => void;
}

interface State {
  zipcodeValue: string;
  distanceValue: string;
  showErrorMessage?: boolean;
}

export default class extends Marko.Component<Input, State> {
  clearErrorMessage() {
    this.state.showErrorMessage = false;
  }

  updateZipcodeValue(value: string) {
    this.state.zipcodeValue = value;
    this.clearErrorMessage();
  }

  useUserZipcode() {
    if (this.input.userLocationZipcode) {
      this.updateZipcodeValue(this.input.userLocationZipcode);
    }
  }

  onCreate(input: Input) {
    const distanceSlider = input.mapParamsGathering?.locationParams?.distanceSlider;
    const distanceOptions = input.mapParamsGathering?.locationParams?.distanceOptions;

    let initialDistance = "";

    if (distanceSlider?.selected) {
      initialDistance = String(distanceSlider.selected);
    } else if (distanceOptions?.entries) {
      const selectedEntry = distanceOptions.entries.find(({ selected }) => selected);
      if (selectedEntry) {
        initialDistance = selectedEntry.fieldId ?? "";
      }
    }

    this.state = {
      zipcodeValue: "",
      distanceValue: initialDistance,
      showErrorMessage: false,
    };
  }

  onPostCodeTextboxChange(e: { value: string }) {
    this.updateZipcodeValue(e.value);
  }

  onDistanceOptionChange(e: { value: string }) {
    this.state.distanceValue = e.value;
  }

  isZipcodeValid() {
    const { zipcodeValue } = this.state;
    const { validation } = this.input.mapParamsGathering?.locationParams?.postalCodeEntry || {};

    return validateZipcode(zipcodeValue, {
      validation,
    });
  }

  async onSubmit() {
    if (await this.isZipcodeValid()) {
      this.emit("close");
      this.emit("submit", {
        zipcode: this.state.zipcodeValue,
        distance: this.state.distanceValue,
      });
    } else {
      this.state.showErrorMessage = true;
    }
  }
}
